export const brandRed = '#ff0049';